import Vue from 'vue'
import VueRouter from 'vue-router'
import ShootPlan from "@/views/ShootPlan";
import CrowdShoot from "@/views/CrowdShoot/CrowdShoot";
import CrowdShootDetail from "@/views/CrowdShoot/CrowdShootDetail";
import Compare from "@/views/CrowdShoot/Compare";
import Viewer from "@/views/CrowdShoot/Viewer";
import ArticleSlidingUpPanel from "@/views/Article/ArticleSlidingUpPanel";
import CompareHorizontal from "@/views/Article/CompareHorizontal";
import RoutePage from "@/views/PhotoLocation/RoutePage";
import RouteSharePage from "@/views/PhotoLocation/RouteSharePage";
import MarkDetailPage  from "@/views/PhotoLocation/MarkDetailPage";
import PanoramaSharePage from "@/views/Panorama/PanoramaSharePage";
import AlumniHeatMap from "../views/AlumniHeatMap/AlumniHeatMap";
import AlumniArticle from "../views/AlumniHeatMap/AlumniArticle";
import CrowdShooting from "@/views/CrowdShooting/CrowdShooting"
import Yijing from "@/views/Yijing/Yijing";
import PlaneRecognition from "../views/PlaneRecognition/PlaneRecognition";
import BubbleNews from "../views/BubbleNews/BubbleNews";
import Drones from "../views/Drones/Drones";
import RollerNews from "../views/RollerNews/RollerNews";
import FireAlarm from "../views/FireAlarm/FireAlarm";
// import Display3D from "@/views/Display3D";
import ImageViewer from "@/views/ImageViewer";
import Event from "@/views/Event/Event";
import productMain from "../views/QuickFlash/productMain";
import LayerCompare from "@/views/LayerCompare/LayerCompare";
import OrbitSatellite from "../views/OrbitSatellite/OrbitSatellite"
import WallpaperSharePage from "@/views/Wallpaper/WallpaperSharePage";
import VideoSharePage from "@/views/Video/VideoSharePage";
import ToolboxSharePage from "@/views/Toolbox/ToolboxSharePage";
import TipsPage from "@/views/Tips/TipsPage";
import ArticleSharePage from "@/views/Article/ArticleSharePage";
import ArticlePage from "@/views/Article/ArticlePage";
import ShootPlanPage from "@/views/ShootPlan/ShootPlanPage";
import miniMap from "../views/QuickFlash/miniMap";
import collectionDetail from "../views/QuickFlash/collectionDetail";
import Agreement from "../views/PrivacyAndAgreement/Agreement";
import Privacy from "../views/PrivacyAndAgreement/Privacy";
import App from "@/views/App";
import OpenApp from "@/views/OpenApp";
import NotExist from "@/views/NotExist";
import Nameing from "../views/OrbitSatellite/Nameing";


Vue.use(VueRouter)

const routes = [
  {
    path: '/ShootPlan',
    name: 'ShootPlan',
    component: ShootPlan
  },
  {
    path: '/CrowdShoot/Home',
    name: 'CrowdShoot',
    component: CrowdShoot
  },
  {
    path: '/CrowdShoot/Detail',
    name: 'CrowdShootDetail',
    component: CrowdShootDetail
  },
  {
    path: '/CrowdShoot/Compare',
    name: 'Compare',
    component: Compare
  },
  {
    path: '/CrowdShoot/Viewer',
    name: 'Viewer',
    component: Viewer
  },
  {
    path: '/Article/ArticleSlidingUpPanel',
    name: 'ArticleSlidingUpPanel',
    component: ArticleSlidingUpPanel
  },
  {
    path: '/Article/CompareHorizontal',
    name: 'CompareHorizontal',
    component: CompareHorizontal
  },
  {
    path: '/Article/ArticleSharePage',
    name: 'ArticleSharePage',
    component: ArticleSharePage
  },
  {
    path: '/Article/ArticlePage',
    name: 'ArticlePage',
    component: ArticlePage
  },

  {
    path: '/PhotoLocation/RouteSharePage',
    name: 'RouteSharePage',
    component: RouteSharePage
  },
  {
    path: '/PhotoLocation/MarkDetailPage',
    name: 'MarkDetailPage',
    component: MarkDetailPage
  },
    {
        path: '/PhotoLocation/RoutePage',
        name: 'RoutePage',
        component: RoutePage
    },
    {
        path:'/Panorama/PanoramaSharePage',
        name:'PanoramaSharePage',
        component:PanoramaSharePage
    },
    {
        path:'/WallpaperSharePage',
        name:'WallpaperSharePage',
        component:WallpaperSharePage
    },
  {
    path:'/VideoSharePage',
    name:'VideoSharePage',
    component:VideoSharePage
  },
    {
        path:'/ToolboxSharePage',
        name:'ToolboxSharePage',
        component:ToolboxSharePage
    },
    {
        path:'/Tips/TipsPage',
        name:'TipsPage',
        component:TipsPage
    },
    {
        path:'/ShootPlanPage',
        name:'ShootPlanPage',
        component:ShootPlanPage
    },


  {
    path: '/AlumniHeatMap/AlumniHeatMap',
    name: 'AlumniHeatMap',
    component: AlumniHeatMap,
    meta:{
      title:"校友会"
    }
  },
  {
    path: '/AlumniHeatMap/AlumniArticle',
    name: 'AlumniArticle',
    component: AlumniArticle,
    meta:{
      title:"校友会"
    }
  },
  {
    path: '/FireAlarm',
    name: 'FireAlarm',
    component: FireAlarm,
    meta:{
      title:"森林火灾风险预警",
    }
  },
  {
    path: '/Yijing',
    name: 'Yijing',
    component: Yijing,
    meta:{
      title:"城市洞察",
    }
  },
  {
    path: '/PlaneRecognition',
    name: 'PlaneRecognition',
    component: PlaneRecognition,
    meta:{
      title:"飞机识别",
    }
  },
  {
    path: '/Drones',
    name: 'Drones',
    component: Drones
  },
  {
    path: '/RollerNews',
    name: 'RollerNews',
    component: RollerNews
  },
  {
    path: '/BubbleNews',
    name: 'BubbleNews',
    component: BubbleNews,
  },
    {
        path:'/CrowdShooting',
        name:'CrowdShooting',
        component: CrowdShooting,
        meta:{
            title:"众筹拍摄"
        }
    },
    {
        path: '/OrbitSatellite',
        name: 'OrbitSatellite',
        component: OrbitSatellite,
    },
  {
    path: '/OrbitSatellite/Nameing',
    name: 'Nameing',
    component: Nameing,
  },
  {
    path: '/Display3D',
    name: 'Display3D',
    component: resolve => require(['../views/Display3D/Display3D'], resolve),
    meta:{
      title:"3D展示",
    }
  },
  {
    path: '/ImageViewer',
    name: 'ImageViewer',
    component: ImageViewer,
    meta:{
      title:"吉林一号卫星影像"
    }
  },
  {
    path: '/Event',
    name: 'Event',
    component: Event,
    meta:{
      title:"共生地球APP活动"
    }
  },
    {
        path: '/LayerCompare',
        name: 'LayerCompare',
        component: LayerCompare,
        meta:{
            title:"卷帘对比"
        }
    },
  {
    path: '/QuickFlash/productMain',
    name: 'QuickFlash',
    component: productMain,
    meta:{
      title:"卫星快闪"
    }
  },
  {
    path: '/QuickFlash/miniMap',
    name: 'miniMap',
    component: miniMap,
    meta:{
    }
  },
  {
    path: '/QuickFlash/collectionDetail',
    name: 'collectionDetail',
    component: collectionDetail,
    meta:{
      title:"卫星快闪"
    }
  },  {
    path: '/PrivacyAndAgreement/agreement',
    name: 'agreement',
    component: Agreement,
    meta:{
      title:"共生地球"
    }
  },  {
    path: '/PrivacyAndAgreement/privacy',
    name: 'privacy',
    component: Privacy,
    meta:{
      title:"共生地球"
    }
  },
  {
    path: '/',
    name: 'app',
    component: App,
    meta:{
      title:"共生地球App"
    }
  },
  {
    path: '/OpenApp',
    name: 'openApp',
    component: OpenApp,
    meta:{
      title:"下载共生地球App"
    }
  },
  {
    path:'/NotExist',
    name:'NotExist',
    component:NotExist,
    meta:{
      title:"共生地球App"
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
